import { useEffect, useState } from 'react';
import api from '../api';

export function useOkunmamisSayisi(aktif: boolean = true) {
  const [sayi, setSayi] = useState(0);

  useEffect(() => {
    if (!aktif) return;
    const kontrol = () => {
      api.get('/api/mesajlar/konusmalar')
        .then(r => {
          const toplam = r.data.reduce((s: number, k: any) => s + Number(k.okunmamis), 0);
          setSayi(toplam);
        })
        .catch(() => {});
    };
    kontrol();
    const interval = setInterval(kontrol, 30000);
    return () => clearInterval(interval);
  }, [aktif]);

  return sayi;
}
